// See cart-drawer.js — window, not a relative import, so cache-busting works.
const lockScroll = (holder) => window.ThemeScrollLock?.lockScroll(holder);
const unlockScroll = (holder) => window.ThemeScrollLock?.unlockScroll(holder);
const trapFocus = (container, initial) => window.ThemeScrollLock?.trapFocus(container, initial);

class SearchOverlay extends HTMLElement {
  connectedCallback() {
    this.panel = this.querySelector('[data-drawer-panel]');
    this.backdrop = this.querySelector('[data-drawer-backdrop]');
    this.input = this.querySelector('[data-search-input]');
    this.results = this.querySelector('[data-search-results]');
    this.releaseFocusTrap = null;
    this.debounceTimer = null;

    this.querySelectorAll('[data-drawer-close]').forEach((el) =>
      el.addEventListener('click', () => this.close())
    );
    this.backdrop?.addEventListener('click', () => this.close());

    // Once only — see site-header.js. A re-connect would otherwise stack a
    // duplicate 'search:open' handler on document for every edit.
    if (!this.hasSetUp) {
      this.hasSetUp = true;
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.isOpen()) this.close();
      });
      document.addEventListener('search:open', () => this.open());
    }

    this.input?.addEventListener('input', () => {
      clearTimeout(this.debounceTimer);
      const query = this.input.value.trim();
      if (query.length < 2) {
        this.results.innerHTML = '';
        return;
      }
      this.debounceTimer = setTimeout(() => this.fetchResults(query), 200);
    });
  }

  isOpen() {
    return this.panel?.getAttribute('data-open') === 'true';
  }

  open() {
    if (!this.panel) return;
    this.panel.setAttribute('data-open', 'true');
    this.backdrop?.setAttribute('data-open', 'true');
    lockScroll(this);
    if (this.releaseFocusTrap) this.releaseFocusTrap();
    this.releaseFocusTrap = trapFocus(this.panel, this.input);
  }

  // Unlock before touching anything that could be missing — see site-header.js.
  close() {
    unlockScroll(this);
    this.panel?.setAttribute('data-open', 'false');
    this.backdrop?.setAttribute('data-open', 'false');
    if (this.releaseFocusTrap) {
      this.releaseFocusTrap();
      this.releaseFocusTrap = null;
    }
  }

  async fetchResults(query) {
    const url = `${window.themeRoutes.predictiveSearch}?q=${encodeURIComponent(
      query
    )}&resources[type]=product&resources[limit]=6&section_id=predictive-search`;
    try {
      const response = await fetch(url);
      const text = await response.text();
      this.results.innerHTML = text;
    } catch (error) {
      this.results.innerHTML = '';
    }
  }
}

if (!customElements.get('search-overlay')) {
  customElements.define('search-overlay', SearchOverlay);
}
